import { CopyButton } from '@/components';

interface WebhookDeliveryCodeBlockProps {
    title: string;
    content: string;
    copyValue?: string | null;
}

export function WebhookDeliveryCodeBlock({
    title,
    content,
    copyValue,
}: WebhookDeliveryCodeBlockProps) {
    return (
        <div className="flex min-w-0 flex-col gap-1.5">
            <div className="flex items-center justify-between">
                <span className="text-xs text-grey-300">{title}</span>
                {copyValue && <CopyButton value={copyValue} />}
            </div>
            <pre className="max-h-72 overflow-auto scrollbar-grey-600 rounded-[6px] border border-grey-600 bg-grey-700 p-3 font-geist-mono text-xs text-grey-200 whitespace-pre-wrap break-words">
                {content}
            </pre>
        </div>
    );
}
